import { useCallback } from 'react';

import useThrottledWindowScrollPosition from 'hooks/useThrottledWindowScrollPosition';

const useProductListingTrackScrollPosition = ({
  hasScrollPositionBeenRestored,
  lastProductPath,
  loadMoreClickCount,
  previousScrollPosition,
  setScrollDataInSessionStorage,
  isScrollTrackingDisabled = false,
}) => {
  const onWindowScrollCallback = useCallback(
    updatedScrollPosition => {
      // Wait to start updating scroll position in session storage until
      // previous scroll position has been restored
      if (!isScrollTrackingDisabled && hasScrollPositionBeenRestored) {
        setScrollDataInSessionStorage(prevData => ({
          ...prevData,
          lastProductPath,
          loadMoreClickCount,
          scrollPosition: updatedScrollPosition,
        }));
      }
    },
    [
      hasScrollPositionBeenRestored,
      isScrollTrackingDisabled,
      lastProductPath,
      loadMoreClickCount,
      setScrollDataInSessionStorage,
    ]
  );

  const callback = useCallback(
    ({ y: updatedScrollPosition }) => {
      if (previousScrollPosition !== updatedScrollPosition) {
        onWindowScrollCallback(updatedScrollPosition);
      }
    },
    [onWindowScrollCallback, previousScrollPosition]
  );

  useThrottledWindowScrollPosition({
    callback,
    time: 100,
    isScrollTrackingDisabled,
  });
};

export default useProductListingTrackScrollPosition;
